import { createFileRoute } from '@tanstack/react-router';
import { SettlementsHub } from '@/components/company/payments/settlements-hub';

export const Route = createFileRoute('/(app)/company/payments/settlements')({
	component: AdvanceSettlementsRoute,
});

function AdvanceSettlementsRoute() {
	return <SettlementsHub />;
}
